var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuBar'),_c('b-card',{staticClass:"m-2 p-4",attrs:{"no-body":""}},[_c('header',[_c('p',{staticClass:"title"},[_vm._v("Dados do responsável técnico")]),_c('div',{staticClass:"close",on:{"click":_vm.close}},[_c('p',{staticClass:"textClose"},[_vm._v("x")])])]),_c('FormResponsavel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }